import classNames from 'classnames';
import ButtonLoadingIcon from 'components/atoms/icons/buttonLoadingIcon';
import BaseSwitch from 'components/atoms/base-switch';
import { useTranslation } from 'react-i18next';
import { useMemo, type FC } from 'react';

import s from './styles.module.scss';

import type { IPatientAssignStateChange } from 'infrastructure/interfaces';

interface AssignSwitchProps {
  isLoading: boolean;
  assignee?: IPatientAssignStateChange['assignee'];
  loginGuid: string;
  checked: boolean;
  onChange: () => void;
}

const AssignSwitch: FC<AssignSwitchProps> = ({
  isLoading,
  assignee,
  loginGuid,
  checked,
  onChange,
}) => {
  const { t } = useTranslation();
  const isAssignedToMe = assignee && assignee.loginGuid === loginGuid;
  const isAssignedToOther = assignee && assignee.loginGuid !== loginGuid;

  const assignedToMeTitle = isAssignedToMe
    ? t('labels.assignedToMe')
    : undefined;
  const isAssignedToOtherTitle = isAssignedToOther
    ? assignee?.fullName
    : undefined;

  const assignedTitle = assignedToMeTitle ?? isAssignedToOtherTitle;

  const assignLabel = useMemo(() => {
    if (assignee) {
      return isAssignedToOther ? '' : t('labels.unassign');
    }
    return t('labels.assign');
  }, [assignee, isAssignedToOther, t]);

  return (
    <div data-cy="reading-assign" className={classNames(s.assign, {})}>
      {isAssignedToOther ? (
        <div className={s['assigned-to-wrapper']}>
          <p>{t('labels.assigned')}: </p>
          <p className={s['assigned-to']}>{assignedTitle}</p>
        </div>
      ) : (
        <p>{assignLabel}</p>
      )}
      {!isAssignedToOther && (
        <div>
          {isLoading ? (
            <ButtonLoadingIcon className={s['spin-loading-icon']} />
          ) : (
            <BaseSwitch
              size="small"
              value={checked}
              onChange={onChange}
              disabled={isLoading || !!isAssignedToOther}
              title={assignedTitle}
            />
          )}
        </div>
      )}
    </div>
  );
};
export default AssignSwitch;
